import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

import { IconUserCircle } from "@tabler/icons";

import { UserProfileProps } from "./index.types";
import { toggleDatePicker } from "store/slices/Main";
import { useDispatch } from "store";

// ==============================|| User Profile ||============================== //

const UserProfile = ({ closePopup }: UserProfileProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <ListItemButton
      sx={{ borderRadius: "8px" }}
      onClick={(e) => {
        closePopup(e);
        navigate("/user-profile");

        // hide date picker
        dispatch(toggleDatePicker(false));
      }}
    >
      <ListItemIcon>
        <IconUserCircle stroke={1.5} size="20px" />
      </ListItemIcon>
      <ListItemText
        primary={<Typography variant="body2">Profile</Typography>}
      />
    </ListItemButton>
  );
};

export default UserProfile;
